<template>
  <div>
    <ubi-panel :title="$t('socialPosts.create.initial.title')" v-loading="loadingStatus">
      <p class="text-justify">{{$t('socialPosts.create.initial.subtitle')}}</p>
    </ubi-panel>
    <ubi-panel class="panel-with-emojis">
      <h3>{{ $t('socialPosts.create.initial.contentPostTitle') }}</h3>
      <el-row>
        <el-col :lg="24">
          <el-form-item :label="$t('socialPosts.create.initial.libelle')" prop="libellePostInput" class="toto">
            <div style="margin-top: -38px; margin-left: 120px">
              <el-tooltip class="item" effect="dark" content="Ce libellé ne sera pas diffusé sur les réseaux sociaux et sera uniquement visible de vous."
                          placement="bottom">
                <em class="el-icon-question"></em>
              </el-tooltip>
            </div>
            <el-input v-model="libellePostInput"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!--      Modale IA Biblio de contenu-->
      <div class="ia-assistant-wrapper">

        <div class="suggestions-container" v-loading="contentLibraryLoading">
          <span class="suggestions-label">Suggestions rapides :</span>
          <el-tooltip
              :disabled="hasInitialLibelleForIa"
              effect="dark"
              :content="$t('socialPosts.create.IAButtonDisabled')"
              placement="top">
            <div class="themes-grid-wrapper" :class="{ 'suggestions-blocked': !hasInitialLibelleForIa }">
              <div class="themes-grid">
                <el-tooltip
                    v-for="tag in suggestionTags"
                    :key="tag.id"
                    :disabled="!hasInitialLibelleForIa"
                    :content="tag.title"
                    placement="top"
                    effect="dark"
                    popper-class="suggestion-tooltip">
                  <span
                      class="theme-tag"
                      :class="{ 'is-disabled': !hasInitialLibelleForIa }"
                      @click="hasInitialLibelleForIa && generateTagContent(tag)">
                    <span class="theme-tag__label">{{ tag.title }}</span>
                  </span>
                </el-tooltip>
              </div>
            </div>
          </el-tooltip>
        </div>

        <div
            class="assistant-button-container"
            :class="{ 'assistant-button-container--ia-loading': loadingStatusIAGeneration }"
            v-loading="loadingStatusIAGeneration"
            :element-loading-text="$t('socialPosts.create.aiGenerationLoading')">
          <el-tooltip
              v-if="!hasInitialLibelleForIa"
              effect="dark"
              :content="$t('socialPosts.create.IAButtonDisabled')"
              placement="top">
            <span class="ia-assistant-tooltip-anchor">
              <el-button type="danger" class="btn-assistant-ia" :disabled="true">
                <i class="el-icon-magic-stick"></i> Mon assistant IA
              </el-button>
            </span>
          </el-tooltip>
          <el-button
              v-else
              type="danger"
              class="btn-assistant-ia"
              :disabled="loadingStatusIAGeneration"
              @click="openModalIA('CHOICE')">
            <i class="el-icon-magic-stick"></i> Mon assistant IA
          </el-button>
          <modal-i-a-post ref="modalAssistantIA"></modal-i-a-post>
        </div>

      </div>

      <div v-if="activeSelectedSujet" class="selected-theme-container">
        <span class="selected-theme-label">{{ $t('socialPosts.create.initial.selectedTheme') }}</span>
        <span class="theme-tag is-selected">
          <span class="theme-tag__label">{{ activeSelectedSujet.title }}</span>
          <i
              class="el-icon-close theme-tag__close"
              @click.stop="clearSuggestionTag()">
          </i>
        </span>
      </div>

      <el-form-item prop="texteInputInitial" class="caption-form-item">
        <div class="textarea-with-emojis">
          <el-input :rows="12" type="textarea" v-model="texteInput" ref="textareaPostEditoInitial"></el-input>
          <Emoji @addEmoji="addEmoji($event)" class="box-emojis" />
        </div>
      </el-form-item>
      <!--      Ancienne version -->
      <!--      <el-row>-->
      <!--        <el-col :lg="24">-->
      <!--          <el-form-item :label="$t('socialPosts.create.initial.textContent')" :prop="modalIA ? '' : 'texteInputInitial'">-->
      <!--            <el-row>-->
      <!--              <el-col :lg="24" class="text-justify"><h5 style="font-size: 0.8125rem;font-family: 'Open Sans', Helvetica, Arial, sans-serif;line-height: 19.5px" v-html="$t('socialPosts.create.initial.textContentInfo')"></h5>-->
      <!--              </el-col>-->
      <!--            </el-row>-->
      <!--            <div v-if="!post.initial.libelle">-->
      <!--              <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.IAButtonDisabled')" placement="bottom">-->
      <!--                <el-button  size="mini" type="success" @click="openModalIAInitial()" :disabled="!post.initial.libelle" style="margin-bottom: 15px;">{{$t('socialPosts.create.redactWithAi')}}</el-button>-->
      <!--              </el-tooltip>-->
      <!--            </div>-->
      <!--            <div v-else>-->
      <!--              <el-button  size="mini" type="success" @click="openModalIAInitial()" style="margin-bottom: 15px;">{{$t('socialPosts.create.redactWithAi')}}</el-button>-->
      <!--            </div>-->
      <!--            <div class="textarea-with-emojis" >-->
      <!--              <el-input :rows="8"-->
      <!--                        type="textarea"-->
      <!--                        v-model="texteInput"-->
      <!--                        ref="textareaPostEditoInitial"-->
      <!--                        >-->
      <!--              </el-input>-->

      <!--              <div>-->
      <!--                <Emoji @addEmoji="addEmoji($event)" class="box-emojis" />-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
    </ubi-panel>

    <ubi-panel>
      <h3>{{$t('socialPosts.create.medias')}}</h3>
      <p>{{$t('socialPosts.create.initial.contentMedia')}}</p>

      <!-- Boutons radio pour choisir entre image et vidéo -->
      <el-row>
        <el-col :lg="24">
          <el-form-item :label="$t('socialPosts.create.mediaType')">

            <el-radio-group v-model="currentMediaType" class="radio-group-media-type">
              <el-radio label="image" :disabled="getStatusMediaPost.hasVideoUrl || getStatusMediaPost.hasVideoUpload">{{ $t('socialMedia.mediaType.imageEdito') }}</el-radio>
              <el-radio label="url" :disabled="getStatusMediaPost.hasVideoUpload || getStatusMediaPost.hasPhotos">{{ $t('socialMedia.mediaType.urlEdito') }}</el-radio>
              <!--              <el-radio label="upload" :disabled="getStatusMediaPost.hasVideoUrl || getStatusMediaPost.hasPhotos">{{ $t('socialMedia.mediaType.uploadEdito') }}</el-radio>-->
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- Section pour les photos - affichée si "image" est sélectionné -->
      <div v-if="currentMediaType === 'image'">
        <el-row>
          <el-col :lg="24">
            <el-form-item>
              <post-edito-photos-upload :post="storePost" network="initial"
                                        :desactiver-champ="false"></post-edito-photos-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- Section pour la vidéo - affichée si "video" est sélectionné -->
      <div v-if="currentMediaType === 'url'">
        <el-form-item :error="inputError" prop="linkToVideoInput">
          <el-row>
            <el-col :span="24">
              <el-input v-model="localVideoUrl" @change="updateLinkToVideo" @input="validateUrlInput" type="url" clearable></el-input>
              <span v-if="localVideoUrl && localVideoUrl.trim() !== ''" class="help" style="color: #f56c6c; display: block; margin-top: 5px;">
                      {{ $t('socialMedia.goBackPicturesOrUpload') }}
              </span>
              <span class="help">{{ $t('posts.networks.videoEditoHelp') }}</span>
            </el-col>
          </el-row>
        </el-form-item>
      </div>

      <UploadVideo
          v-if="currentMediaType === 'upload'"
          :post="storePost"
          networkName="initial"
      ></UploadVideo>
    </ubi-panel>
  </div>
</template>

<script>

import Emoji from '@/components/emojis/Emoji'
import { mapGetters, mapMutations, mapState } from 'vuex'
import PostEditoPhotosUpload from '@/pages/socialNetworks/components/PostEditoPhotosUpload'
import { $t } from '@/i18n'
import UbiPanel from '@/components/Panel.vue'
import UploadVideo from '@/components/Upload/UploadVideo.vue'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { fetchContentLibraryItems } from '@/services/contentLibrary'
import ModalIAPost from '@/components/ContentSuggestionLibrary/ModalIAPost.vue'

export default {
  name: 'PostEditoCreatePublicationInitiale',
  components: {
    UploadVideo,
    UbiPanel,
    Emoji,
    PostEditoPhotosUpload,
    ModalIAPost
  },
  props: ['post'],
  data () {
    return {
      loadingStatus: false,
      inputError: '',
      mediaType: '',
      localVideoUrl: '',
      manualMediaTypeSelection: false, // Flag pour savoir si l'utilisateur a fait une sélection manuelle
      activeSelectedSujet: null,
      suggestionTags: [],
      contentLibraryLoading: false
    }
  },
  watch: {
    // Surveiller les changements de l'URL vidéo
    linkToVideoInput: {
      handler (newValue) {
        // Synchroniser la valeur locale avec le store
        if (newValue !== this.localVideoUrl) {
          this.localVideoUrl = newValue
        }
        this.updateMediaType()
      },
      immediate: true
    },
    // Surveiller les changements des images dans le store
    '$store.state.socialPostsCreationPostEditorial.post.initial.pictures': {
      handler (newValue) {
        // console.log('photos post initial from store', newValue) // debug
        this.updateMediaType()
      },
      deep: true,
      immediate: true
    },
    // Watcher pour synchroniser mediaType avec le store (simplifié car on utilise getMediaType)
    getStatusMediaPost: {
      handler (newStatus) {
        // console.log('getStatusMediaPost changed:', newStatus) // debug
        // La logique de détection est maintenant dans le getter getMediaType
        // Ce watcher sert principalement pour les effets de bord
      },
      deep: true,
      immediate: true
    },
    // Watcher pour savoir si on a une vidéo URL
    hasValidVideoUrl: {
      handler (newValue) {
        this.$store.commit('socialPostsCreationPostEditorial/setStatusMediasPost', { key: 'hasVideoUrl', value: newValue })
      },
      immediate: true
    },
    // Watcher pour savoir si on a une vidéo Uploaded
    hasUploadedVideo: {
      handler (newValue) {
        this.$store.commit('socialPostsCreationPostEditorial/setStatusMediasPost', { key: 'hasVideoUpload', value: newValue })
        this.updateMediaType()
      },
      immediate: true
    },
    // Watcher pour détecter les changements automatiques du type de média
    getMediaType: {
      handler (newType, oldType) {
        // Si pas de sélection manuelle et que le type automatique change, l'adopter
        if (!this.manualMediaTypeSelection && newType !== oldType) {
          this.mediaType = newType
        }
      },
      immediate: true
    },
    '$store.state.socialPostsCreationPostEditorial.post.initial.studioSujetId': {
      async handler (studioSujetId) {
        if (studioSujetId == null || studioSujetId === '') {
          this.activeSelectedSujet = null
          return
        }
        await this.syncActiveSelectedSujet(String(studioSujetId))
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('socialPostsCreationPostEditorial', ['getStatusMediaPost', 'getMediaType', 'hasAnyMedia', 'getUploadedVideoPath']),
    ...mapState('socialPostsCreationPostEditorial', ['watcherNewPic', 'draftButtonAvailable', 'publishButtonAvailable', 'loadingStatusIAGeneration']),
    texteInput: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.initial.inputText
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/updateInputTextInitial', value)
        this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
        this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
      }
    },
    libellePostInput: {
      get () {
        return this.$store.state.socialPostsCreationPostEditorial.post.initial.libelle
      },
      set (value) {
        this.updateLibelleInitial(value)
      }
    },
    linkToVideoInput: {
      get () {
        // Vérifier si la structure du store exists
        if (this.$store.state.socialPostsCreationPostEditorial &&
            this.$store.state.socialPostsCreationPostEditorial.post &&
            this.$store.state.socialPostsCreationPostEditorial.post.initial) {
          return this.$store.state.socialPostsCreationPostEditorial.post.initial.linkToVideo || ''
        }
        return ''
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/updateInputVideoInitial', value)
      }
    },
    /** Post du store : aligné sur libellé / texte / médias (évite décal avec la prop). */
    storePost () {
      return this.$store.getters['socialPostsCreationPostEditorial/getPost']
    },
    modalIA () {
      return this.$store.state.socialPostsCreationPostEditorial.modalIA
    },
    /** Aligné sur l’ancien « Rédiger avec l’IA » : libellé obligatoire avant assistant / suggestions rapides */
    hasInitialLibelleForIa () {
      const s = this.$store.state.socialPostsCreationPostEditorial
      const lib = s && s.post && s.post.initial ? s.post.initial.libelle : ''
      return lib != null && String(lib).trim() !== ''
    },
    hasValidVideoUrl () {
      return this.urlIsValid(this.localVideoUrl) && this.localVideoUrl && this.localVideoUrl.trim() !== ''
    },
    hasUploadedVideo () {
      const statusMediasPost = this.$store.getters['socialPostsCreationPostEditorial/getStatusMediaPost']
      return statusMediasPost && statusMediasPost.hasVideoUpload
    },
    hasPhotos () {
      const postFromStore = this.storePost
      const hasPhotosInDB =
          (this.post && this.post.photos && this.post.photos.length > 0) ||
          (postFromStore && postFromStore.photos && postFromStore.photos.length > 0)

      const hasPhotosInStore = (postFromStore.initial.pictures && postFromStore.initial.pictures.length > 0) ||
          (postFromStore.facebook.pictures && postFromStore.facebook.pictures.length > 0) ||
          (postFromStore.instagram.pictures && postFromStore.instagram.pictures.length > 0) ||
          (postFromStore.google.pictures && postFromStore.google.pictures.length > 0) ||
          (postFromStore.linkedin.pictures && postFromStore.linkedin.pictures.length > 0)
      return hasPhotosInDB || hasPhotosInStore
    },

    // Utiliser le getter centralisé pour le type de média avec possibilité de sélection manuelle
    currentMediaType: {
      get () {
        // Si l'utilisateur a fait une sélection manuelle, la respecter
        if (this.manualMediaTypeSelection) {
          return this.mediaType
        }
        // Sinon, utiliser le getter automatique
        return this.getMediaType
      },
      set (value) {
        // Permettre la sélection manuelle
        this.manualMediaTypeSelection = true
        this.mediaType = value
      }
    }
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial', ['setModalIA', 'setWatcherNewPic', 'setNetworkClicked']),
    sujetId (sujet) {
      return sujet != null && sujet.id != null ? String(sujet.id) : ''
    },
    sujetInsertText (sujet) {
      if (!sujet) return ''
      const desc = sujet.description
      if (desc != null && String(desc).trim() !== '') return desc
      return sujet.instruction || ''
    },
    generateTagContent (tag) {
      if (!this.hasInitialLibelleForIa || this.loadingStatusIAGeneration) return
      this.activeSelectedSujet = tag
      this.$store.dispatch('socialPostsCreationPostEditorial/dispatchEditorialIaGeneration', {
        network: 'initial',
        studioSujetId: this.sujetId(tag),
        promptUtilisateur: ''
      })
    },
    clearSuggestionTag () {
      this.activeSelectedSujet = null
      this.$store.commit('socialPostsCreationPostEditorial/clearStudioSujetContext')
      this.texteInput = ''
      this.$nextTick(() => {
        this.triggerCaptionValidation()
      })
    },
    triggerCaptionValidation () {
      let parent = this.$parent
      while (parent) {
        if (parent.$refs && parent.$refs.formEdito) {
          parent.$refs.formEdito.validateField('texteInputInitial')
          return
        }
        parent = parent.$parent
      }
    },
    async syncActiveSelectedSujet (normalizedId) {
      if (!normalizedId) {
        this.activeSelectedSujet = null
        return
      }
      if (this.activeSelectedSujet && this.sujetId(this.activeSelectedSujet) === normalizedId) return

      const fromSuggestions = this.suggestionTags.find(tag => this.sujetId(tag) === normalizedId)
      if (fromSuggestions) {
        this.activeSelectedSujet = fromSuggestions
        return
      }

      try {
        const items = await fetchContentLibraryItems()
        const activeItems = items.filter(item => !item.state || item.state === 'ACTIVE')
        this.activeSelectedSujet = activeItems.find(item => this.sujetId(item) === normalizedId) || null
      } catch (e) {
        this.activeSelectedSujet = null
      }
    },
    async loadContentLibrarySuggestions () {
      this.contentLibraryLoading = true
      try {
        const items = await fetchContentLibraryItems()
        const activeItems = items.filter(item => !item.state || item.state === 'ACTIVE')
        // Suggestions rapides : 3 sujets aléatoires de la bibliothèque
        const shuffled = [...activeItems].sort(() => Math.random() - 0.5)
        this.suggestionTags = shuffled.slice(0, 3)
        const studioSujetId = this.$store.state.socialPostsCreationPostEditorial.post.initial.studioSujetId
        if (studioSujetId != null && studioSujetId !== '') {
          await this.syncActiveSelectedSujet(String(studioSujetId))
        }
      } catch (e) {
        this.suggestionTags = []
        this.$message({
          message: this.$t('socialPosts.create.modalIaPost.themesFetchFailed'),
          type: 'info',
          duration: 8000
        })
      } finally {
        this.contentLibraryLoading = false
      }
    },
    openModalIA (step, themeId = null) {
      if (!this.hasInitialLibelleForIa || this.loadingStatusIAGeneration) return
      if (this.$refs.modalAssistantIA) {
        this.$refs.modalAssistantIA.init(step, themeId)
      }
    },
    onMediaTypeChange (newType) {
      this.manualMediaTypeSelection = true
      this.mediaType = newType
    },
    // Méthode utilitaire pour rafraîchir l'analyse des médias
    async refreshMediaAnalysis () {
      try {
        await this.$store.dispatch('socialPostsCreationPostEditorial/refreshMediaAnalysis')
      } catch (error) {
      }
    },
    // openModalIAInitial () {
    //   this.setNetworkClicked('initial')
    //   this.setModalIA(true)
    // },
    addEmoji (emoji) {
      const insertText = emoji
      if (!insertText.length) {
        return
      }
      const textarea = this.$refs.textareaPostEditoInitial.$el.querySelector('.el-textarea__inner')
      let cursorIndex = textarea.selectionEnd
      if (textarea.innerHTML === '' && !this.texteInput) {
        textarea.innerHTML += insertText
      }
      if (this.texteInput) {
        this.texteInput = this.texteInput.substring(0, cursorIndex) + insertText + this.texteInput.substring(cursorIndex)
      } else {
        this.texteInput = insertText
      }

      setTimeout(() => {
        cursorIndex += insertText.length
        textarea.selectionStart = textarea.selectionEnd = cursorIndex
      }, 10)
    },
    updateLibelleInitial (value) {
      this.$store.commit('socialPostsCreationPostEditorial/updateLibelleInitial', value)
      this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
      this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
    },
    validateUrlInput (value) {
      // Validation en temps réel pendant la saisie (comme dans PostManager.vue)
      this.inputError = ''
      if (value && !this.urlIsValid(value)) {
        this.inputError = $t('posts.networks.videoUrlError')
      }
    },
    updateLinkToVideo (value) {
      this.inputError = ''
      if (!value || this.urlIsValid(value)) {
        // Mettre à jour seulement lors du @change, pas à chaque frappe
        this.$store.commit('socialPostsCreationPostEditorial/updateInputVideoInitial', value)
        // Déclencher la mise à jour des statuts médias après la mise à jour du store
        this.$nextTick(() => {
          this.updateMediaType()
        })
      } else {
        this.inputError = $t('posts.networks.videoUrlError')
        this.$emit('updateValue', 'setError', this.inputError)
        this.$store.commit('socialPostsCreationPostEditorial/setPublishButtonAvailable', true)
        this.$store.commit('socialPostsCreationPostEditorial/setDraftButtonAvailable', true)
        this.$message({ message: $t('posts.networks.videoUrlError'), type: 'error', duration: 10000 })
        return false
      }
    },
    urlIsValid (urlString) {
      let isValid = false
      try {
        const urlVideo = new URL(urlString)
        isValid = (
          ((urlVideo.protocol === 'http:') || (urlVideo.protocol === 'https:')) &&
            (urlVideo.hostname.indexOf('youtube') === -1) &&
            (urlVideo.hostname.indexOf('dailymotion') === -1)
        )
      } catch (_) {
      }
      return isValid
    },
    updateMediaType () {
      const hasValidVideo = this.hasValidVideoUrl
      // Utiliser directement les données du store pour être sûr d'avoir la bonne référence
      const storePhotos = this.$store.state.socialPostsCreationPostEditorial.post.initial.pictures
      const hasImages = storePhotos && storePhotos.length > 0
      const hasUploadedVideo = this.hasUploadedVideo

      // console.log('updateMediaType - hasImages:', hasImages, 'storePhotos.length:', storePhotos ? storePhotos.length : 'undefined') // debug

      // Mettre à jour explicitement les statuts dans le store
      this.$store.commit('socialPostsCreationPostEditorial/setStatusMediasPost', { key: 'hasVideoUrl', value: hasValidVideo })
      this.$store.commit('socialPostsCreationPostEditorial/setStatusMediasPost', { key: 'hasVideoUpload', value: hasUploadedVideo })
      this.$store.commit('socialPostsCreationPostEditorial/setStatusMediasPost', { key: 'hasPhotos', value: hasImages })

      // Détecter s'il y a un conflit et le stocker sans afficher la modale
      const hasConflict = Boolean((hasValidVideo || hasUploadedVideo) && hasImages)
      this.$store.commit('socialPostsCreationPostEditorial/setHasMediaConflict', hasConflict)

      // Appeler les fonctions de validation des boutons du store
      // Ces fonctions vérifient les médias dans le store (pas en BDD) pour déterminer si l'utilisateur peut enregistrer
      this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState')
      this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState')
    }
  },
  mounted () {
    // Initialiser localVideoUrl avec la valeur du store
    this.localVideoUrl = this.linkToVideoInput
    this.loadContentLibrarySuggestions()

    if (this.$route.params.id) {
      // Charger le post via le store éditorial
      this.$store.dispatch('socialPostsCreationPostEditorial/loadSocialPostEditorialById', this.$route.params.id)
        .then(() => {
          // Attendre que le post soit complètement chargé avant l'analyse
          this.$nextTick(() => {
            // Déclencher l'analyse centralisée des médias UNE SEULE FOIS au montage
            setTimeout(() => {
              this.$store.dispatch('socialPostsCreationPostEditorial/analyzePostMedias', this.$route.params.id)
            }, 200) // Augmenter le délai pour s'assurer que le post est chargé

            // Initialiser l'URL du clap si elle existe - syntaxe compatible
            const currentPost = this.$store.getters['socialPostsCreationPostEditorial/getCurrentPost']
            if (currentPost && currentPost.donnees && currentPost.donnees.url_clap && currentPost.donnees.url_clap.valeur !== '') {
              this.$store.commit('socialPostsCreationPostEditorial/updateInputVideoInitial', currentPost.donnees.url_clap.valeur)
              this.localVideoUrl = currentPost.donnees.url_clap.valeur
            }
          })
        })
    } else {
      // Pour les nouveaux posts (création), déclencher l'analyse pour les vidéos temporaires
      setTimeout(() => {
        this.$store.dispatch('socialPostsCreationPostEditorial/analyzePostMedias', null)
      }, 100)

      // Garde fou pour cleaner le repertoire de vidéos temporaires en cas de reste
      HTTP_HYPER_ESPACE_BACKEND.delete('/videos/cleanup')
        .then(response => {
          // console.log(response)
          if (response.data && response.data.status === 200) {
            // Nettoyer le cache et les états du store
            this.$store.commit('socialPostsCreationPostEditorial/clearTemporaryVideosCache')
            this.$store.commit('socialPostsCreationPostEditorial/setStatusMediasPost', { key: 'hasVideoUpload', value: false })
            this.$store.commit('socialPostsCreationPostEditorial/clearUploadedVideoPath')
          }
        })
    }
  },
  destroyed () {
    this.$store.commit('socialPostsCreationPostEditorial/setCurrentPost', null)
    // Reset du flag de sélection manuelle
    this.manualMediaTypeSelection = false
    this.$store.commit('socialPostsCreationPostEditorial/clearTemporaryVideosCache')
    this.$store.commit('socialPostsCreationPostEditorial/setStatusMediasPost', { key: 'hasVideoUpload', value: false })
    this.$store.commit('socialPostsCreationPostEditorial/clearUploadedVideoPath')
  }
}
</script>

<style lang="scss" scoped>
.textarea-with-emojis {
  position: relative;
}

.box-emojis {
  position: absolute;
  bottom: 0px;
  right: 5px;
  z-index: 3;
}

.panel-with-emojis {
  min-height: 450px;
  padding-bottom: 80px;

  .selected-theme-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;

    .selected-theme-label {
      font-size: 0.85rem;
      font-weight: bold;
      color: var(--color-black);
      flex-shrink: 0;
    }

    .theme-tag {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 6px 12px;
      border: 1px solid var(--color-blue);
      border-radius: 4px;
      background-color: var(--color-blue);
      color: #fff;
      font-size: 0.875rem;
      cursor: default;
      max-width: 280px;
      user-select: none;

      &__label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #fff;
      }

      &__close {
        flex-shrink: 0;
        font-size: 11px;
        color: #fff;
        cursor: pointer;
        opacity: 0.75;
        &:hover {
          opacity: 1;
        }
      }
    }
  }
}

.caption-form-item {
  margin-bottom: 0;

  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-form-item__label {
  color: var(--color-black);
  line-height: 1.5;
  font-weight: bold !important;
}

.radio-group-media-type {
  display: flex;
  flex-direction: column;
}
.ia-assistant-wrapper {
  margin-bottom: 20px;
  background-color: var(--color-white);
  padding: 10px 0;

  .suggestions-container {
    margin-bottom: 15px;

    .suggestions-label {
      font-size: 0.85rem;
      font-weight: bold;
      color: var(--color-black);
      display: block;
      margin-bottom: 8px;
    }

    .themes-grid-wrapper {
      max-height: 180px;
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 5px;
      padding: 12px;
      border-radius: 6px;
      display: flex;
      width: 100%;

      &.suggestions-blocked {
        opacity: 0.55;
      }
    }

    .themes-grid {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 10px;
      width: 100%;

      .theme-tag {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        background-color: #fff;
        color: var(--color-black);
        font-size: 0.875rem;
        cursor: pointer;
        max-width: 180px;
        transition: border-color 0.2s, color 0.2s, background-color 0.2s;
        user-select: none;

        &__label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: inherit;
        }

        &__close {
          flex-shrink: 0;
          font-size: 11px;
          color: inherit;
          opacity: 0.75;
          &:hover {
            opacity: 1;
          }
        }

        &:hover:not(.is-disabled):not(.is-selected) {
          border-color: var(--color-blue);
          color: var(--color-blue);
        }

        &.is-selected {
          background-color: var(--color-blue);
          border-color: var(--color-blue);
          color: #fff !important;

          &:hover {
            background-color: var(--color-blue);
            border-color: var(--color-blue);
            color: #fff !important;
          }

          .theme-tag__label,
          .theme-tag__close {
            color: #fff !important;
          }
        }

        &.is-disabled {
          cursor: not-allowed;
          opacity: 0.55;
        }
      }
    }
  }

  .assistant-button-container {
    text-align: center;
    position: relative;

    &--ia-loading {
      min-height: 100px;
    }

    .ia-assistant-tooltip-anchor {
      display: inline-block;
    }

    .btn-assistant-ia {
      background-color: var(--color-red);
      border-color: var(--color-red);
      color: #fff;
      padding: 10px 24px;
      font-weight: 600;
      font-size: 1rem;
      border-radius: 6px;
      &:hover, &:focus {
        background-color: darken(#d24554, 8%) !important;
        border-color: darken(#d24554, 8%) !important;
        outline: none !important;
        box-shadow: none !important;
      }
      i {
        font-size: 1rem;
        margin-right: 8px;
        vertical-align: middle;
      }
    }
  }
}
</style>
